 <template>
        <div :style="{'min-height':minHeight}"  style="width:100%;background-color:rgba(0,0,0,0.05);display: flex;flex-direction: column;align-items: center;justify-content: flex-start;">
            <div style="width:900px;margin:20px 0;">
                <table border="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 100%; border-collapse: collapse;">
                    <tr style="height: 40px;">
                        <td colspan="2">
                            <div style="display:flex;border-bottom: 1px dashed #c40001;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-volume-high.png" style="width:20px;height:20px;">            
                                <div style="font-size:20px;color:#c40001;font-weight: bolder;height: 40px;line-height: 40px;margin-left:10px;">
                                    招聘公告
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="newsList.length>0" @click="goNews(item.id)" v-for="item in newsList"  style="cursor: pointer;height: 40px;color:#888888;font-size:14px;font-weight: 400;">
                        <td>
                            <div style="display:flex;justify-content: flex-start;align-items: center;">
                                <img src="../../static/other/ios-volume-sm.png" style="width:16px;height:16px;">            
                                <div style="font-size:14px;height: 30px;line-height: 30px;margin-left:10px; ">
                                    {{item.newsTitle.length>20?item.newsTitle.substring(0,20)+'...':item.newsTitle}}
                                </div>
                            </div>
                        </td>
                        <td style="text-align: right;">
                            {{item.createTime.substring(0,10)}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
</template>
<script>
    export default{
        data(){
            return{
                newsList:[],  
                minHeight:'100%',           
            }
        },
        methods:{    
            goNews(newsId){
                this.$router.push({name:'PreviewFile',query:{newsId:newsId}});
            },      
            getDataList:function(){
                var that = this;
                this.$axios.get(this.Global.globalUrl+'/interface/getJobNewsMore.ashx'
                    ,{                       
                        headers:{
                            'token':JSON.stringify(this.getToken())
                        }
                    }
                    ).then((res) => {
                            if (res.data.err==0){
                                that.newsList=res.data.newsList;                               
                            }else{
                                this.$message({                                   
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        }
                    )
                    .catch(() => {
                    })
                    .finally(()=>{
                        this.loading=false;
                    })

            },

        },
        mounted(){
            this.$nextTick(function () {
                this.minHeight = (document.documentElement.clientHeight -200)+'px';
                this.getDataList();
            })
           
        },
        created(){
        }
    }
</script>